


<app-website-header></app-website-header>

<div class="container-fluid">

        <section class="about">
            <div class="row">
                <div class="col-sm" style="height: 10px;"></div>
                <div class="col-md" style="height: 24px"></div>
            </div>


            <div class="row">
                <div class="col-sm-1"></div>

                <div class="col-sm-5">
                    <div class="row">
                        <div class="about-image">
                            <p style="object-fit: contain;
                                    font-family: Raleway;
                                    font-size: 45px;
                                    font-weight: 600;
                                    font-stretch: normal;
                                    font-style: normal;
                                    line-height: 1.33;
                                    letter-spacing: 0.32px;
                                    text-align: left;
                                    color: #ff6d11;">Refund Status</p>
                        </div>
                    </div>
                    <div class="row">
                        <p class="refund-text">State Refund Status</p> <br>
                    </div>
                    <div class="row">
                        <p><a href="http://www.statetaxinformation.com/stateinfo.aspx" target="blank" class="refund-links">http://www.statetaxinformation.com/stateinfo.aspx</a></p>
                    </div>

                    <div class="row">
                        <div class="col-sm" style="height: 10px;"></div>
                        <div class="col-md" style="height: 24px"></div>
                    </div>

                    <div class="row">
                        <p class="refund-text">Federal Refund Status</p> <br>
                    </div>
                    <div class="row">
                        <p><a href="https://sa.www4.irs.gov/irfof/lang/en/irfofgetstatus.jsp" target="blank" class="refund-links">https://sa.www4.irs.gov/irfof/lang/en/irfofgetstatus.jsp</a>
                        </p>
                    </div>

                </div>
                <div class="col-sm-5">
                    <img src="assets/section-images/Group 1229.png"
                        style="width: 249px;height: 210px;object-fit: contain;">
                </div>

                <div class="col-sm-1"></div>
            </div>

            <div class="row">
                <div class="col-sm" style="height: 10px;"></div>
                <div class="col-md" style="height: 70px"></div>
            </div>


            <div class="row">
                <div class="col-sm-1"></div>
                <div class="col-sm-5">
                    <img src="assets/section-images/Group 1235.png">
                </div>
                <div class="col-sm-5">
                    <div class="row">
                        <div class="about-image">
                            <p style="object-fit: contain;
                                    font-family: Raleway;
                                    font-size: 45px;
                                    font-weight: 600;
                                    font-stretch: normal;
                                    font-style: normal;
                                    line-height: 1.33;
                                    letter-spacing: 0.32px;
                                    text-align: left;
                                    color: #ff6d11;">Pay Taxes Online</p>
                        </div>
                    </div>
                    <div class="row">
                        <p class="refund-text">Pay state taxes online</p> <br>
                    </div>
                    <div class="row">
                        <p><a href="https://www.officialpayments.com/index.jsp" target="blank" class="refund-links">https://www.officialpayments.com/index.jsp</a></p>
                    </div>

                    <div class="row">
                        <div class="col-sm" style="height: 10px;"></div>
                        <div class="col-md" style="height: 24px"></div>
                    </div>

                    <div class="row">
                        <p class="refund-text">Pay Federal taxes online</p> <br>
                    </div>
                    <div class="row">
                        <p><a href="https://www.officialpayments.com/index.jsp" target="blank" class="refund-links">https://www.officialpayments.com/index.jsp</a></p>
                    </div>

                </div>
                <div class="col-sm-1"></div>
            </div>


            <div class="row">
                <!-- <div class="col" style="height: 1px;"></div> -->
                <div class="col-sm" style="height: 10px;"></div>
                <div class="col-md" style="height: 50px"></div>
                <!-- <div class="col-lg" style="height: 150px;"></div> -->
            </div>


            <div class="row">
                <div class="col-sm-1"></div>

                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://sa.www4.irs.gov/wmar/login" target="blank"><span class="refund-cols"> Amendment </span></a> 
                </div>
                <div class="col-sm"><span class="icon-color"> > </span> 
                    <a href="https://www.idr.iowa.gov/wheresmyrefund/GetRefundStatus" target="blank">
                        <span class="refund-cols"> Iowa </span>
                    </a>
                    
                </div>
                <div class="col-sm"><span class="icon-color"> > </span> 
                    <a href="https://revenue.nebraska.gov/individuals/refund-information" target="blank">
                        <span class="refund-cols"> Nebraska </span>
                    </a>
                    
                </div>
                <div class="col-sm"><span class="icon-color"> > </span> 
                    <a href="https://www.ri.gov/taxation/refund/" target="blank">
                        <span class="refund-cols"> Rhode Island </span>
                    </a>
                </div>
                <div class="col-sm-1"></div>
            </div>

            <div class="row">
                <!-- <div class="col" style="height: 1px;"></div> -->
                <div class="col-sm" style="height: 10px;"></div>
                <div class="col-md" style="height: 30px"></div>
                <!-- <div class="col-lg" style="height: 150px;"></div> -->
            </div>

            <div class="row">
                <div class="col-sm-1"></div>

                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://myalabamataxes.alabama.gov/_/" target="blank">
                    <span class="refund-cols"> Alabama </span>
                </a>
                    
                </div>
                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://www.kdor.org/refundstatus/default.asp" target="blank">
                    <span class="refund-cols"> kansas </span>
                </a>
                    
                </div>
                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://evolvtax.com/refund" target="blank">
                    <span class="refund-cols"> Nevada </span>
                </a>
                    
                </div>
                <div class="col-sm"><span class="icon-color"> > </span>
                <a href="https://dor.sc.gov/refund" target="blank">
                    <span class="refund-cols"> South Carolina
                    </span>
                </a> 
                </div>
                <div class="col-sm-1"></div>
            </div>

            <div class="row">
                <!-- <div class="col" style="height: 1px;"></div> -->
                <div class="col-sm" style="height: 10px;"></div>
                <div class="col-md" style="height: 30px"></div>
                <!-- <div class="col-lg" style="height: 150px;"></div> -->
            </div>

            <div class="row">
                <div class="col-sm-1"></div>

                <div class="col-sm"><span class="icon-color"> > </span>
                    <a href="https://atap.arkansas.gov/_/#1" target="blank"><span class="refund-cols"> Arkansas </span></a>
                 
                </div>
                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://iiulefundstatus.ky.gov/ulFWeb/" target="blank">
                    <span class="refund-cols"> Kentucky </span>
                </a>
                    
                </div>
                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://evolvtax.com/refund" target="blank">
                    <span class="refund-cols"> New Hampshire </span>
                </a>
                    
                </div>
                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://evolvtax.com/refund" target="blank">
                    <span class="refund-cols"> South Dakota </span>
                </a>
                    
                </div>
                <div class="col-sm-1"></div>
            </div>

            <div class="row">
                <!-- <div class="col" style="height: 1px;"></div> -->
                <div class="col-sm" style="height: 10px;"></div>
                <div class="col-md" style="height: 30px"></div>
                <!-- <div class="col-lg" style="height: 150px;"></div> -->
            </div>

            <div class="row">
                <div class="col-sm-1"></div>

                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://webapp.ftb.ca.gov/refund/Main/NotFound?aspxerrorpath=/refund/login.aspx" target="blank">
                    <span class="refund-cols"> California </span>
                </a>
                    
                </div>
                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://latap.revenue.louisiana.gov/_/" target="blank">
                    <span class="refund-cols"> Louisiana </span>
                </a>
                    
                </div>
                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://www16.state.nj.us/TYul_TGI_INQ/jsp/prompt.jsp" target="blank">
                    <span class="refund-cols"> New Jersey </span>
                </a>
                    
                </div>
                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://evolvtax.com/refund" target="blank">
                    <span class="refund-cols"> Tennessee </span>
                </a>
                    
                </div>
                <div class="col-sm-1"></div>
            </div>

            <div class="row">
                <!-- <div class="col" style="height: 1px;"></div> -->
                <div class="col-sm" style="height: 10px;"></div>
                <div class="col-md" style="height: 30px"></div>
                <!-- <div class="col-lg" style="height: 150px;"></div> -->
            </div>

            <div class="row">
                <div class="col-sm-1"></div>

                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://www.colorado.gov/revenueonline/_/#1" target="blank">
                    <span class="refund-cols"> Colorado </span>
                </a>
                    
                </div>
                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://portal.maine.gov/refundstatus/refund" target="blank">
                    <span class="refund-cols"> Maine </span>
                </a>
                    
                </div>
                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://evolvtax.com/refund" target="blank">
                    <span class="refund-cols"> New Mexico </span>
                </a>
                    
                </div>
                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://evolvtax.com/refund" target="blank">
                    <span class="refund-cols"> Texas </span>
                </a>
                    
                </div>
                <div class="col-sm-1"></div>
            </div>

            <div class="row">
                <!-- <div class="col" style="height: 1px;"></div> -->
                <div class="col-sm" style="height: 10px;"></div>
                <div class="col-md" style="height: 30px"></div>
                <!-- <div class="col-lg" style="height: 150px;"></div> -->
            </div>

            <div class="row">
                <div class="col-sm-1"></div>

                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://drsindtax.ct.gov/AUT/SessionTimeout.aspx" target="blank">
                    <span class="refund-cols"> connecticut </span>
                </a>
                    
                </div>
                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://interactive.marylandtaxes.gov/INDIV/refundstatus/home.aspx" target="blank">
                    <span class="refund-cols"> Maryland </span>
                </a>
                    
                </div>
                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://www.tax.ny.gov/pit/file/refund.htm" target="blank">
                    <span class="refund-cols"> New York </span>
                </a>
                    
                </div>
                <div class="col-sm"><span class="icon-color"> > </span> <a href="http://incometax.utah.gov/refunds/wheres-my-refund" target="blank">
                    <span class="refund-cols"> Utah </span>
                </a>
                    
                </div>
                <div class="col-sm-1"></div>
            </div>

            <div class="row">
                <!-- <div class="col" style="height: 1px;"></div> -->
                <div class="col-sm" style="height: 10px;"></div>
                <div class="col-md" style="height: 30px"></div>
                <!-- <div class="col-lg" style="height: 150px;"></div> -->
            </div>

            <div class="row">
                <div class="col-sm-1"></div>

                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://dorweb.revenue.delaware.gov/scripts/refinq/refinq.dll" target="blank">
                    <span class="refund-cols"> Delaware </span>
                </a>
                    
                </div>
                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://www.mass.gov/orgs/massachusetts-department-of-revenue" target="blank">
                    <span class="refund-cols"> Massachusetts </span>
                </a>
                    
                </div>
                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://eservices.dor.nc.gov/wheresmyrefund/SelectionServlet" target="blank">
                    <span class="refund-cols"> North Carolina
                    </span>
                </a>
                    
                </div>
                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://tax.vermont.gov/individuals/file-and-pay/check-refund-status" target="blank">
                    <span class="refund-cols"> Vermont </span>
                </a>
                    
                </div>
                <div class="col-sm-1"></div>
            </div>

            <div class="row">
                <!-- <div class="col" style="height: 1px;"></div> -->
                <div class="col-sm" style="height: 10px;"></div>
                <div class="col-md" style="height: 30px"></div>
                <!-- <div class="col-lg" style="height: 150px;"></div> -->
            </div>

            <div class="row">
                <div class="col-sm-1"></div>

                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://sa.www4.irs.gov/irfof/lang/en/irfofgetstatus.jsp" target="blank">
                    <span class="refund-cols"> Federal </span>
                </a>
                    
                </div>
                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://www.michigan.gov/taxes/0,4676,7-238-43513_75466---,00.html" target="blank">
                    <span class="refund-cols"> Michigan </span>
                </a>
                    
                </div>
                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://www.nd.gov/tax/user/individuals/overview/where-s-my-refund" target="blank">
                    <span class="refund-cols"> North Dakota </span>
                </a>
                    
                </div>
                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://www.individual.tax.virginia.gov/VTOL/tax/IndRefundStatus.xhtml" target="blank">
                    <span class="refund-cols"> Virginia </span>
                </a>
                    
                </div>
                <div class="col-sm-1"></div>
            </div>

            <div class="row">
                <!-- <div class="col" style="height: 1px;"></div> -->
                <div class="col-sm" style="height: 10px;"></div>
                <div class="col-md" style="height: 30px"></div>
                <!-- <div class="col-lg" style="height: 150px;"></div> -->
            </div>

            <div class="row">
                <div class="col-sm-1"></div>

                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://dor.georgia.gov/wheres-my-refund" target="blank">
                    <span class="refund-cols"> Georgia </span>
                </a>
                    
                </div>
                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://www.mndor.state.mn.us/tp/refund/_/" target="blank">
                    <span class="refund-cols"> Minnesota </span>
                </a>
                    
                </div>
                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://www.tax.ohio.gov/Individual.aspx" target="blank">
                    <span class="refund-cols"> Ohio </span>
                </a>
                    
                </div>
                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://evolvtax.com/refund" target="blank">
                    <span class="refund-cols"> Washington </span>
                </a>
                    
                </div>
                <div class="col-sm-1"></div>
            </div>

            <div class="row">
                <!-- <div class="col" style="height: 1px;"></div> -->
                <div class="col-sm" style="height: 10px;"></div>
                <div class="col-md" style="height: 30px"></div>
                <!-- <div class="col-lg" style="height: 150px;"></div> -->
            </div>

            <div class="row">
                <div class="col-sm-1"></div>

                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://idahotap.gentax.com/tap/_/#1" target="blank">
                    <span class="refund-cols"> Idaho </span>
                </a>
                    
                </div>
                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://tap.dor.ms.gov/_/" target="blank">
                    <span class="refund-cols"> Mississippi </span>
                </a>
                    
                </div>
                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://www.ok.gov/tax/Individuals/Income_Tax/Filing_Information/How_to_Check_on_a_Refund/" target="blank">
                    <span class="refund-cols"> Oklahoma </span>
                </a>
                    
                </div>
                <div class="col-sm"><span class="icon-color"> > </span> <a href="http://revenue.wv.gov/pages/where'smyrefund.aspx" target="blank">
                    <span class="refund-cols"> west Virginia </span>
                </a>
                    
                </div>
                <div class="col-sm-1"></div>
            </div>

            <div class="row">
                <!-- <div class="col" style="height: 1px;"></div> -->
                <div class="col-sm" style="height: 10px;"></div>
                <div class="col-md" style="height: 30px"></div>
                <!-- <div class="col-lg" style="height: 150px;"></div> -->
            </div>

            <div class="row">
                <div class="col-sm-1"></div>

                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://mytax.illinois.gov/_/#1" target="blank">
                    <span class="refund-cols"> Illinois </span>
                </a>
                    
                </div>
                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://dors.mo.gov/tax/taxinq/welcome.jsp" target="blank">
                    <span class="refund-cols"> Missouri </span>
                </a>
                    
                </div>
                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://revenueonline.dor.oregon.gov/tap/_/" target="blank">
                     <span class="refund-cols"> Oregon </span>
                </a>
                   
                </div>
                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://www.revenue.wi.gov/Pages/Apps/TaxReturnStatus.aspx" target="blank">
                    <span class="refund-cols"> Wisconsin </span>
                </a>
                    
                </div>
                <div class="col-sm-1"></div>
            </div>

            <div class="row">
                <!-- <div class="col" style="height: 1px;"></div> -->
                <div class="col-sm" style="height: 10px;"></div>
                <div class="col-md" style="height: 30px"></div>
                <!-- <div class="col-lg" style="height: 150px;"></div> -->
            </div>

            <div class="row">
                <div class="col-sm-1"></div>

                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://secure.in.gov/apps/dor/tax/refund/" target="blank">
                    <span class="refund-cols"> Indiana </span>
                </a>
                    
                </div>
                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://tap.dor.mt.gov/_/" target="blank">
                    <span class="refund-cols"> Montana </span>
                </a>
                    
                </div>
                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://www.doreservices.state.pa.us/PITServices/WheresMy/Refund" target="blank">
                    <span class="refund-cols"> Pennysylvania </span>
                </a>
                    
                </div>
                <div class="col-sm"><span class="icon-color"> > </span> <a href="https://evolvtax.com/refund" target="blank">
                    <span class="refund-cols"> Wyoming </span>
                </a>
                    
                </div>
                <div class="col-sm-1"></div>
            </div>

            <div class="row">
                <!-- <div class="col" style="height: 1px;"></div> -->
                <div class="col-sm" style="height: 10px;"></div>
                <div class="col-md" style="height: 60px"></div>
                <!-- <div class="col-lg" style="height: 150px;"></div> -->
            </div>

            <div class="row">
                <div class="col-sm-1"></div>

                <div class="col-sm-5" style="margin-top: 62px;">
                    <p class="need-help">NEED HELP?</p> <br>
                    <p class="need-content">
                        Contact our customer support team if you have any further questions. We are here to help you
                        out.
                    </p> <br>

                    <a href="tel:+1(888)690-5754">
                        <button class="btn  btn-sm Number" id="right" style="width: 250px;
                                    height: 50px;
                                    object-fit: contain;
                                    border-radius: 25px;
                                    background-color: #ff6d11;
                                    color: white;">
                        +1 (888) 690 - 5754 &nbsp;
                    </button>
                    </a>
                </div>

                <div class="col-sm-5">
                    <img src="assets/section-images/Group 1364.png">
                </div>

                <div class="col-sm-1"></div>
            </div>

            <div class="row">
                <!-- <div class="col" style="height: 1px;"></div> -->
                <div class="col-sm" style="height: 10px;"></div>
                <div class="col-md" style="height: 65px"></div>
                <!-- <div class="col-lg" style="height: 150px;"></div> -->
            </div>
        </section>

    </div>

    
<app-website-footer></app-website-footer>